// extracted by mini-css-extract-plugin
export default {"row":"DataTable_row__JPng3"};